<template>
  <div class="columns">
    <div class="column is-6">
      <p class="is-subtitle is-secondary is-bold">
        Trademark Search, Classification & Registration
      </p>
      <p class="py-5">
        You’re building a distinct brand. Start the process to protect your
        brand by registering it as a trademark.
      </p>
      <p class="pb-5">
        You’re building your brand the right way and now we encourage you to
        protect your investment. Securing a trademark registration for your
        brand is the surest way to stay safe from any future ownership
        challenges. Start the process with Brandeeq by getting help from an
        expert:
      </p>
      <p class="pb-5">Please provide the following information.</p>
      <form @submit.prevent="submit" id="editorForm">
        <div class="mt-5">
          <p class="is-secondary is-semi-bold mt-4 pt-4">
            CNIC/NICOP/Passport number
          </p>
          <div class="my-5">
            <b-input
              v-model="responses.q1"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">
            Mobile/cell phone number
          </p>
          <div class="my-5">
            <b-input
              v-model="responses.q2"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">
            Active email address
          </p>
          <div class="my-5">
            <b-input
              v-model="responses.q3"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">Name of applicant</p>
          <div class="my-5">
            <b-input
              v-model="responses.q4"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">Residential address</p>
          <div class="my-5">
            <b-input
              v-model="responses.q5"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">Nationality</p>
          <div class="my-5">
            <b-input
              v-model="responses.q6"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">
            Product or service of application
          </p>
          <div class="my-5">
            <b-input
              v-model="responses.q7"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">
            Description of product or service
          </p>
          <div class="my-5">
            <b-input
              v-model="responses.q8"
              :disabled="locked"
              required
            ></b-input>
          </div>

          <p class="is-secondary is-semi-bold mt-4 pt-4">
            Representation of trademark (an image or logo)
          </p>
          <div class="my-5 pb-5">
            <section>
              <b-field>
                <b-upload v-model="dropFiles" multiple drag-drop required>
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"> </b-icon>
                      </p>
                      <p>Drop your files here or click to upload</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="tags">
                <span
                  v-for="(file, index) in dropFiles"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)"
                  ></button>
                </span>
              </div>
            </section>
          </div>

          <div class="my-5 pt-5">
            <button
              form="editorForm"
              class="button is-info"
              type="submit"
              :disabled="isSubmitting"
            >
              <i class="mdi mdi-check mr-1"></i>
              {{ isSubmitting ? "Submitting Response" : "Submit Response" }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="column has-text-centered">
      <img
        src="@/assets/img/service_illustrations/trademark_protection_illustration.svg"
        width="90%"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Trademark",
  props: {
    locked: Boolean,
  },
  computed: {
    orderId() {
      return this.$route.query.orderId;
    },
    serviceId() {
      return this.$route.query.id;
    },
  },
  data() {
    return {
      isSubmitting: false,
      order: undefined,
      dropFiles: [],
      responses: {
        q1: undefined,
        q2: undefined,
        q3: undefined,
        q4: undefined,
        q5: undefined,
        q6: undefined,
        q7: undefined,
        q8: undefined,
        q9: undefined,
      },
      questions: {
        q1: "CNIC/NICOP/Passport number",
        q2: "Mobile/cell phone number",
        q3: "Active email address",
        q4: "Name of applicant",
        q5: "Residential address",
        q6: "Nationality",
        q7: "Product or service of application",
        q8: "Description of product or service",
        q9: "Representation of trademark (an image or logo)",
      },
    };
  },
  methods: {
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
    async createOrder() {
      this.order = await this.$store.dispatch("createOrder", this.serviceId);
    },
    async submitQuestions() {
      await this.$store.dispatch("submitQuestions", {
        id: this.orderId,
        request: { questions: this.questions },
      });
    },
    async submitResponses() {
      const request = new FormData();
      request.append("file", this.dropFiles[0]);
      const uploadedFileLink = await this.$store.dispatch(
        "uploadResponse",
        request
      );
      this.responses.q9 = "FILE#" + uploadedFileLink;
      await this.$store.dispatch("submitResponses", {
        id: this.orderId,
        request: { responses: this.responses },
      });
    },
    async submit() {
      this.isSubmitting = true;
      await this.submitQuestions();
      await this.submitResponses();
      this.$router.push({ name: "Dashboard" });
      this.isSubmitting = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/main.scss";
</style>
